<template>
  <div class="lang-select">
    <Icon type="md-globe" size="24" class="global-icon" />
      <Select style="width:130px" :transfer="true" v-model="lang" size="small" @on-change="changeLang">
        <template #prefix>
          <img v-if="lang === 'zh-cn'" class="lang-icon-prefix" src="@/assets/img/lang-chinese.png" />
          <img v-else-if="lang === 'en-us'" class="lang-icon-prefix" src="@/assets/img/lang-english.png" />
          <img v-else-if="lang === 'fr-fr'" class="lang-icon-prefix" src="@/assets/img/lang-french.png" />
          <img v-else-if="lang === 'ko-kr'" class="lang-icon-prefix" src="@/assets/img/lang-korean.png" />
          <img v-else-if="lang === 'de-de'" class="lang-icon-prefix" src="@/assets/img/lang-german.png" />
          <img v-else-if="lang === 'pt-br'" class="lang-icon-prefix" src="@/assets/img/lang-brazil.png" />
        
        </template>
        <Option value="zh-cn"><img class="lang-icon" src="@/assets/img/lang-chinese.png" />中文</Option>
        <Option value="en-us"><img class="lang-icon" src="@/assets/img/lang-english.png" />English</Option>
        <Option value="fr-fr"><img class="lang-icon" src="@/assets/img/lang-french.png" />Français</Option>
        <Option value="ko-kr"><img class="lang-icon" src="@/assets/img/lang-korean.png" />한국어</Option>
        <Option value="de-de"><img class="lang-icon" src="@/assets/img/lang-german.png" />Deutsch</Option>
        <Option value="pt-br"><img class="lang-icon" src="@/assets/img/lang-brazil.png" />Português</Option>
      </Select>


  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

import { API_URL } from '@/constants/const.js'
import { postJsError } from '@/util/util.js'
import axios from 'axios';
export default {
  name: 'LangSelect',
  computed: {
    ...mapGetters(['getTranslation', 'getLanguage']),
    lang: {
      get() {
        // store 是当前会话的数据源，localStorage 只在页面初始加载时同步进来
        return this.getLanguage;
      },
      set(val) {
        // 只更新 store 内存状态，不持久化
        // localStorage 等 changeLang API 成功后再写
        this.updateLanguage(val);
      }
    }
  },
  components: {
   
  },
  data() {
    return {
    }
  },
  created() {
    
  },
  methods: {
    ...mapActions(['updateLanguage']),
    async initLang() {
      let localLang = localStorage.getItem('system.lang');
      if (localLang) {
        this.lang = localLang;
      }
    },
    async changeLang() {
      let url = API_URL["langChange"];
      let realLang = this.lang;
      if (realLang == '') {
        return;
      }
      // 保存旧值，API 失败时用于回退
      let oldLang = localStorage.getItem('system.lang') || this.getLanguage;
      axios.get(url, {
        params: {
          "lang": realLang
        }
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            // API 成功才持久化
            localStorage.setItem('system.lang', realLang);
            window.location.reload();
          } else {
            // 失败：回退 store 和 localStorage
            this.updateLanguage(oldLang);
            localStorage.setItem('system.lang', oldLang);
            this.$Message.error(this.getTranslation('c019'));
          }
        })
        .catch((err) => {
          postJsError(err);
          // 失败：回退 store 和 localStorage
          this.updateLanguage(oldLang);
          localStorage.setItem('system.lang', oldLang);         
        })
    },    
  }
}
</script>

<style scoped>
.lang-select{
  display:inline-block;
  position:relative;
  align-items: center;
  text-align:left;
}
.global-icon {
  display: inline-block;
  margin-right: 6px;
  color: #5bb7ff;
  vertical-align: middle;

}

.lang-icon {
  height: 18px;
  width:18px;
  margin-right: 6px;
  vertical-align: middle;
  text-align:left;
}

.lang-icon-prefix {
  height: 16px;
  width:16px;
  margin-right: 4px;
  vertical-align: middle;
  text-align:left;
}
</style>